/**
 * 「这一行背后已经没有任何账号」——清单行的**结构性无供给**判据（唯一入口）。
 *
 * 背景（llm-gateway#354，产品经理 2026-10-08 拍板）：网关把模型清单当「模型资料」——
 * 某个 (分组, 模型, 协议) 格子在该分组里已没有任何账号服务它时，这一行**不再消失**，
 * 而是照常下发（公开清单 `/api/v1/model-catalog` 与 DOSIA bundle 都是），标
 * `available === false` + `unavailable_reason === "no_credential"`、不带 retry_after；
 * bundle 里这行还带该组自己的 key。只有显式下线才移除行。在这之前这类格子根本不存在。
 *
 * 于是 DOSIA 有两类消费点要分开：
 *  · **选择 / 展示 / 下线判定**（选择器隐藏、`reconcileDefaultBrain` 接管、个人订阅行按同 id
 *    复用元数据、`isRetiredFromLiveCatalog`）——它们本来就只认 `available === false` 或要读这行的
 *    资料，看见这行是新语义要的结果，**不经本谓词**。
 *  · **取用 / 可路由 / 候选**（首启默认模型、云端与服务端取模型、托管搜索端点、档位可路由、
 *    工具候选）——它们只看「行在不在」，以前零账号的模型没有行而被自然跳过，现在会选中一条必定
 *    503 的行。这些点**一律把本谓词为真的行当作不存在**，与网关改动前逐字节等价。
 *
 * 其它不可用原因（`maintenance` / `rate_limited` / `quota_exhausted` / `probe_failed` …）**不归本
 * 谓词**：它们一直以「不可用行」的身份存在，是运行时瞬时态（`claudeChainRoutableBaseIds` 头注
 * 「刻意不看 available」那一条），把它们也当不存在会让一次限流引起档位表、工具池抖动。
 *
 * 两种字段形状都收：camelCase（`ModelCatalogEntry` / `EnterpriseBundleModel`，`unavailableReason`）
 * 与网关 wire 的 snake_case（`WireModel`，`unavailable_reason`）——agent-host / apps/web 直接消费
 * wire 行，判据只该有一份（红线 #9）。入参来自持久化 JSON 或网络，运行时 guard，不信类型。
 */
/** 网关「这一格已没有任何账号」的原因码（网关 `aggregateUnavailableReason` 空输入那一支）。 */
export const NO_CREDENTIAL_UNAVAILABLE_REASON = "no_credential";
/**
 * 该行是否「结构性无供给」：`available === false` 且原因码恰为 `no_credential`。
 * 非对象 / 缺字段 / 其它原因 / `available !== false` 一律 false（按「有供给」处置——
 * 与可用性契约「字段缺席 = unknown ≠ 不可用」同一安全档）。
 */
export function isNoCredentialRow(row) {
    if (!row || typeof row !== "object")
        return false;
    const r = row;
    if (r.available !== false)
        return false;
    const reason = r.unavailableReason ?? r.unavailable_reason;
    return reason === NO_CREDENTIAL_UNAVAILABLE_REASON;
}
/** 去掉结构性无供给行，其余（含畸形行，交给调用方既有 guard）原样保序返回。 */
export function dropNoCredentialRows(rows) {
    return rows.filter((row) => !isNoCredentialRow(row));
}
//# sourceMappingURL=catalog-row-supply.js.map